/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../Interceptor/Interseptor'
import {message} from 'antd'
import {withRouter} from 'react-router-dom'

class EditProcessCategory extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      title: null
    }
  }

  submit(e) {
    e.preventDefault()
  }

  componentDidMount() {
    let {id} = this.props.match.params
    this.getById(id)
  }

  getById = (id) => {
    return http
      .get(`process-category/${id}/get`, {})
      .then((res) => {
        if (res.data.error === null) {
          this.setState({
            title: res.data.object.title
          })
        }
      })
      .catch(() => {})
  }

  editCartStation() {
    let title = document.getElementById('title').value.trim()
    if (title === '') {
      message.error('فیلد های ستاره دار انتخاب شود')
    } else {
      let data = {
        title
      }
      let {id} = this.props.match.params
      http
        .put(`process-category/${id}/update`, data, {})
        .then((res) => {
          if (res.data.error === null) {
            message.success(' با موفقیت ویرایش شد')
            setTimeout(() => {
              window.location.assign('/base/deliveryStatus/processCategories')
            }, 3000)
          } else {
            message.error(res.data.description)
          }
        })
        .catch(() => {})
    }
  }

  render() {
    return (
      <div className="rtl printA4Page">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>مدیریت فرایندها</li>
            <li>ویرایش دسته فرایند</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ویرایش دسته فرایند</p>
            </div>
            <div className="formComponent selectComponent">
              <label>
                عنوان :<span className="requireFiled">*</span>‌
              </label>
              <input type="text" id="title" defaultValue={this.state.title} className="form-control" />
            </div>

            <div className="formComponent selectComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.editCartStation.bind(this)}>
                ویرایش
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default EditProcessCategory
